import { render, staticRenderFns } from "./SubGatewayReport.vue?vue&type=template&id=06951bb4"
import script from "./SubGatewayReport.vue?vue&type=script&lang=js"
export * from "./SubGatewayReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports